
import axios from 'axios'
import { Toast, Dialog } from 'vant'
// http request 拦截器
axios.interceptors.request.use(
  config => {
    config.headers = {
      'Content-Type': 'application/json',
    }
    let tokenId = localStorage.getItem("tokenJK");
    if (tokenId) {
      config.headers['access-token'] = tokenId;
      config.headers['Authorization'] = 'JWT ' + tokenId;
    }
    return config
  },
  err => {
    return Promise.reject(err)
  })

// http response 拦截器
axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (error.response.data.data == undefined) {
      if (error.response.status == 401) {
        // Toast(error.response.data.return_msg)
        Dialog.alert({
          message: error.response.data.return_msg,
        }).then(() => {
          // on close
        });
      } else if (error.response.status == 400) {
        // Toast(error.response.data.return_msg)
        Dialog.alert({
          message: error.response.data.return_msg,
        }).then(() => {
          // on close
        });
      } else if (error.response.status == 403) {
        // Toast(error.response.data.return_msg)
        Dialog.alert({
          message: error.response.data.return_msg,
        }).then(() => {
          // on close
        });
      }
      else if (error.response.status == 422) {
        // Toast(error.response.data.return_msg)
        Dialog.alert({
          message: error.response.data.return_msg,
        }).then(() => {
          // on close
        });
      }
      else if (error.response.status == 500) {
        // Toast(error.response.data.return_msg)
        Dialog.alert({
          message: '服务器出错，请稍后再试',
        }).then(() => {
          // on close
        });
      }
      else {
        // Toast(error.response.data.return_msg)
        Dialog.alert({
          message: error.response.data.return_msg,
        }).then(() => {
          // on close
        });
      }
    } else {
      // Toast(error.response.data.return_msg)
      Dialog.alert({
        message: error.response.data.return_msg,
      }).then(() => {
        // on close
      });
    }
    return Promise.reject(error)
  })


// WEBPACK FOOTER //
// ./src/utils/http.js